import { useMemo } from 'react';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { metricsLeadService, type MetricsLead, type ListMetricsLeadsParams } from '../services';

export interface UseMetricsLeadsFilters extends ListMetricsLeadsParams {
  enabled?: boolean;
}

export const useMetricsLeads = (
  filters: UseMetricsLeadsFilters,
): UseQueryResult<MetricsLead[], Error> => {
  const queryParams = useMemo(() => {
    const {
      status,
      channel,
      loyaltyCustomerId,
      searchTerm,
      createdFrom,
      createdTo,
      cnpj,
      enabled,
    } = filters;

    return {
      status,
      channel: channel?.trim() || undefined,
      loyaltyCustomerId: loyaltyCustomerId?.trim() || undefined,
      searchTerm: searchTerm?.trim() || undefined,
      createdFrom: createdFrom || undefined,
      createdTo: createdTo || undefined,
      cnpj: cnpj?.replace(/\D/g, '') || undefined,
      enabled: enabled ?? true,
    } satisfies UseMetricsLeadsFilters;
  }, [filters]);

  return useQuery<MetricsLead[], Error>({
    queryKey: ['metrics-leads', queryParams],
    queryFn: () =>
      metricsLeadService.listLeads({
        status: queryParams.status,
        channel: queryParams.channel,
        loyaltyCustomerId: queryParams.loyaltyCustomerId,
        searchTerm: queryParams.searchTerm,
        createdFrom: queryParams.createdFrom,
        createdTo: queryParams.createdTo,
        cnpj: queryParams.cnpj,
      }),
    enabled: queryParams.enabled !== false,
    staleTime: 1000 * 60 * 2,
  });
};
